import { get } from "./apiService";

export const fetchDashboardStats = async (id) => {
  return get({ path: `Dashboard/stats` });
}